  

import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Capteur, CapteurPayload, CapteursService } from '../../../services/capteurs.service';
import { StatutCapteursService, StatutCapteur } from '../../../services/statut-capteurs.service';
import { LotCartouche, LotsCartouchesService } from '../../../services/lots-cartouches.service';
import { Nomenclature, NomenclaturesService } from '../../../services/nomenclatures.service';
import { CommandesService } from '../../../services/commandes.service';
import { Cartouche, CartouchesService } from '../../../services/cartouches.service';
import { TypeCapteur, TypeCapteursService } from '../../../services/type-capteurs.service';

@Component({
  selector: 'app-modifier-capteur',
  imports: [CommonModule, FormsModule, MatAutocompleteModule, MatOptionModule],
  templateUrl: './modifier-capteur.component.html',
  styleUrl: './modifier-capteur.component.scss'
})
export class ModifierCapteurComponent implements OnInit {

  private pendingCapteurId: number | null = null;

  lotCartoucheAName: string = '';
  lotCartoucheBName: string = '';
  typeCapteurs: TypeCapteur[] = [];
  typeCapteur = '';
  statutCapteurId: number | null = null;
  statutsCapteurs: StatutCapteur[] = [];
  cartoucheAInput: string = '';
  cartoucheBInput: string = '';
  filteredCartouchesA: any[] = [];
  filteredCartouchesB: any[] = [];
  cartoucheAId: number | null = null;
  cartoucheBId: number | null = null;
  lignesCommandeEnPreparation: any[] = [];
  selectedLigneCommandeId: number | null = null;

  

  // Pour l'autocomplete cartouche A
  onCartoucheAInputChange(value: string): void {
    const trimmedValue = value ? value.trim() : '';

    if (!trimmedValue) {
      this.cartoucheAId = null;
      this.lotCartoucheAName = '';
    }
    
    if (trimmedValue.length >= 1) {
      // Recherche avec au moins 1 caractère
      this.cartouchesService.autocompleteNom(trimmedValue).subscribe(cartouches => {
        this.filteredCartouchesA = cartouches;
        const exactMatch = cartouches.find((cartouche: Cartouche) => (cartouche.nom ?? '') === trimmedValue);
        if (exactMatch) {
          this.cartoucheAId = exactMatch.id;
          this.lotCartoucheAName = this.getLotName(exactMatch.lot_cartouche_id);
        } else {
          this.cartoucheAId = null;
          this.lotCartoucheAName = '';
        }
        this.cdr.markForCheck();
      });
    } else if (trimmedValue.length === 0) {
      // Champ vide, afficher les 10 premiers
      this.cartouchesService.autocompleteNom('').subscribe(cartouches => {
        this.filteredCartouchesA = cartouches;
        this.cdr.markForCheck();
      });
    }
  }


  onCartoucheASelected(event: any): void {
    const cartouche = event.option.value;
    this.cartoucheAInput = cartouche.nom;
    this.cartoucheAId = cartouche.id;
    this.lotCartoucheAName = this.getLotName(cartouche.lot_cartouche_id);
    this.cdr.markForCheck();
  }

  private formatLigneCommandeAffichage(ligne: any): string {
    return `${ligne.numero_commande} (Ligne #${ligne.id})${ligne.type_capteur ? ' - ' + ligne.type_capteur : ''}${(ligne.nom_cartouche_a || ligne.nom_cartouche_b) ? ' - ' + [ligne.nom_cartouche_a, ligne.nom_cartouche_b].filter(Boolean).join(' / ') : ''}${ligne.date_expedition ? ' - ' + this.formatDateFr(ligne.date_expedition) : ''}`;
  }

  private formatDateFr(dateString: string): string {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR');
    } catch {
      return dateString;
    }
  }

  // Pour l'autocomplete cartouche B
  onCartoucheBInputChange(value: string): void {
    const trimmedValue = value ? value.trim() : '';

    if (!trimmedValue) {
      this.cartoucheBId = null;
      this.lotCartoucheBName = '';
    }
    
    if (trimmedValue.length >= 1) {
      // Recherche avec au moins 1 caractère
      this.cartouchesService.autocompleteNom(trimmedValue).subscribe(cartouches => {
        this.filteredCartouchesB = cartouches;
        const exactMatch = cartouches.find((cartouche: Cartouche) => (cartouche.nom ?? '') === trimmedValue);
        if (exactMatch) {
          this.cartoucheBId = exactMatch.id;
          this.lotCartoucheBName = this.getLotName(exactMatch.lot_cartouche_id);
        } else {
          this.cartoucheBId = null;
          this.lotCartoucheBName = '';
        }
        this.cdr.markForCheck();
      });
    } else if (trimmedValue.length === 0) {
      // Champ vide, afficher les 10 premiers
      this.cartouchesService.autocompleteNom('').subscribe(cartouches => {
        this.filteredCartouchesB = cartouches;
        this.cdr.markForCheck();
      });
    }
  }
  onCartoucheBSelected(event: any): void {
    const cartouche = event.option.value;
    this.cartoucheBInput = cartouche.nom;
    this.cartoucheBId = cartouche.id;
    this.lotCartoucheBName = this.getLotName(cartouche.lot_cartouche_id);
    this.cdr.markForCheck();
  }

  displayCartouche(value: Cartouche | string | null): string {
    if (!value) {
      return '';
    }

    return typeof value === 'string' ? value : (value.nom ?? '');
  }

  // Utilitaire pour afficher le nom du lot
  getLotName(lotId?: number): string {
    if (!lotId) return '';
    const lot = this.lotsCartouches.find(l => l.id === lotId);
    return lot ? lot.nom : '';
  }



 
  protected capteurs: Capteur[] = [];
  protected lotsCartouches: LotCartouche[] = [];
  protected nomenclatures: Nomenclature[] = [];
  protected selectedCapteurId = '';
  protected selectedLotAId = '';
  protected selectedLotBId = '';

  protected numeroSerie = '';
  protected dateAssemblage = '';
  protected numeroNomenclature = '';
  protected codeCartoucheA = '';
  protected codeCartoucheB = '';
  protected dateEmballage = '';
  protected codeBonRetour = '';
  protected codeBonRetourCartouches = '';
  protected dateEnvoi = '';
  protected dateExpeditionCapteur = '';
  protected referenceEnvoi = '';
  protected dateRetour = '';
  protected nombreHeuresFonctionnement = '';
  protected nombreLitresAspires = '';
  protected presenceCartouche = false;
  protected testMoteur = false;
  protected commentaire = '';
  protected macCarteElectronique = '';

  protected loading = false;
  protected loadingCapteurs = false;
  protected loadingNomenclatures = false;
  protected success = '';
  protected error = '';
  capteurFabriqueInput = '';
  filteredCapteursFabriques: Capteur[] = [];

  private normalizeNombreHeuresFonctionnement(value: string): string | undefined | null {
    const normalized = value.trim();
    if (!normalized) {
      return undefined;
    }
    if (!/^\d{3}h\d{2}$/.test(normalized)) {
      this.error = "Le nombre d'heures de fonctionnement doit respecter le format 008h12.";
      return null;
    }
    return normalized;
  }

  constructor(
    private readonly capteurService: CapteursService,
    private readonly lotsService: LotsCartouchesService,
    private readonly nomenclaturesService: NomenclaturesService,
    private readonly zone: NgZone,
    private readonly cdr: ChangeDetectorRef,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly commandesService: CommandesService,
    private readonly cartouchesService: CartouchesService,
    private readonly statutCapteursService: StatutCapteursService,
    private readonly typeCapteursService: TypeCapteursService
  ) {}


  ngOnInit(): void {
    this.lignesCommandeEnPreparation = [];
    this.route.queryParams.subscribe((params) => {
      const queryCapteurId = Number(params['capteurId']);
      if (Number.isFinite(queryCapteurId) && queryCapteurId > 0) {
        this.pendingCapteurId = queryCapteurId;
        this.selectedCapteurId = String(queryCapteurId);
        if (this.capteurs.length > 0) {
          this.onCapteurSelect();
          this.pendingCapteurId = null;
        }
      }
    });
    this.loadCapteurs();
    this.loadLots();
    this.loadNomenclatures();
    this.loadTypeCapteurs();
    this.loadStatutsCapteurs();
    this.loadLignesCommandeEnPreparation();
  }

  private loadTypeCapteurs(): void {
    this.typeCapteursService.list().subscribe({
      next: (types: TypeCapteur[]) => {
        this.typeCapteurs = types;
        this.cdr.markForCheck();
      },
      error: () => {
        this.typeCapteurs = [];
        this.cdr.markForCheck();
      }
    });
  }

  private loadLignesCommandeEnPreparation(): void {
    this.commandesService.listLignesEnCoursDePreparation().subscribe({
      next: (response) => {
        const items = response?.items ?? [];
        this.lignesCommandeEnPreparation = items.map((ligne) => ({
          ...ligne,
          _affichage: this.formatLigneCommandeAffichage(ligne),
        }));

        if (this.selectedLigneCommandeId) {
          const exists = this.lignesCommandeEnPreparation.some((l) => l.id === this.selectedLigneCommandeId);
          if (!exists) {
            this.selectedLigneCommandeId = null;
          }
        }
        this.cdr.markForCheck();
      },
      error: () => {
        this.lignesCommandeEnPreparation = [];
        this.cdr.markForCheck();
      }
    });
  }

  protected onLigneCommandeChange(): void {
    if (!this.selectedLigneCommandeId || !this.typeCapteur) {
      return;
    }

    const selectedLigne = this.lignesCommandeEnPreparation.find(
      (ligne) => ligne.id === this.selectedLigneCommandeId
    );
    if (!selectedLigne?.type_capteur) {
      return;
    }

    const ligneType = this.normalizeTypeCapteur(selectedLigne.type_capteur);
    const capteurType = this.normalizeTypeCapteur(this.typeCapteur);
    if (ligneType && capteurType && ligneType !== capteurType) {
      alert(
        `Attention: la ligne de commande est de type "${selectedLigne.type_capteur}" alors que le capteur est de type "${this.typeCapteur}".`
      );
    }
  }

  protected onTypeCapteurChange(): void {
    if (this.isSingleCartoucheType()) {
      this.clearCartoucheBSelection();
    }
    this.onLigneCommandeChange();
  }

  protected isSingleCartoucheType(): boolean {
    return this.normalizeTypeCapteur(this.typeCapteur).startsWith('1 cartouche');
  }

  protected getCartoucheALabel(): string {
    return this.isSingleCartoucheType() ? 'Cartouche' : 'Cartouche A';
  }

  protected getLotCartoucheALabel(): string {
    return this.isSingleCartoucheType() ? 'Lot cartouche' : 'Lot cartouche A';
  }

  private clearCartoucheBSelection(): void {
    this.cartoucheBId = null;
    this.cartoucheBInput = '';
    this.lotCartoucheBName = '';
    this.filteredCartouchesB = [];
  }

  private normalizeTypeCapteur(value: string | null | undefined): string {
    return String(value ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  private loadStatutsCapteurs(): void {
    this.statutCapteursService.list().subscribe({
      next: (statuts) => {
        this.statutsCapteurs = statuts;
        this.cdr.markForCheck();
      },
      error: () => {
        this.statutsCapteurs = [];
        this.cdr.markForCheck();
      }
    });
  }

  protected isStatutEnCoursDeTransit(): boolean {
    const statutId = Number(this.statutCapteurId);
    if (!Number.isFinite(statutId) || statutId <= 0) {
      return false;
    }

    const statut = this.statutsCapteurs.find((s) => s.id === statutId);
    const nom = String(statut?.nom ?? '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
    return nom === 'en cours de transit';
  }

  protected onCapteurSelect(): void {
    const selected = this.capteurs.find((c) => c.id === Number(this.selectedCapteurId));
    if (selected) {
      this.capteurFabriqueInput = selected.numero_serie;
      this.typeCapteur = selected.type_capteur || '';
      this.numeroSerie = selected.numero_serie;
      this.dateAssemblage = selected.date_assemblage;
      this.numeroNomenclature = String(selected.numero_nomenclature);
      this.selectedLigneCommandeId = selected.ligne_commande_id || null;
      // Cartouche A
      this.cartoucheAId = selected.cartouche_a ?? null;
      if (this.cartoucheAId) {
        this.cartouchesService.get(this.cartoucheAId).subscribe(cartouche => {
          this.cartoucheAInput = cartouche.nom || '';
          this.lotCartoucheAName = this.getLotName(cartouche.lot_cartouche_id);
          this.cdr.markForCheck();
        });
      } else {
        this.cartoucheAInput = '';
        this.lotCartoucheAName = '';
      }
      // Cartouche B
      this.cartoucheBId = selected.cartouche_b ?? null;
      if (this.cartoucheBId && !this.isSingleCartoucheType()) {
        this.cartouchesService.get(this.cartoucheBId).subscribe(cartouche => {
          this.cartoucheBInput = cartouche.nom || '';
          this.lotCartoucheBName = this.getLotName(cartouche.lot_cartouche_id);
          this.cdr.markForCheck();
        });
      } else {
        this.clearCartoucheBSelection();
      }
      this.dateEmballage = selected.date_emballage;
      this.codeBonRetour = selected.code_bon_retour;
      this.codeBonRetourCartouches = selected.code_bon_retour_cartouches;
      this.dateEnvoi = selected.date_envoi ?? selected.date_expedition ?? '';
      this.dateExpeditionCapteur = selected.date_expedition ?? '';
      this.referenceEnvoi = selected.reference_envoi;
      this.dateRetour = selected.date_retour;
      this.nombreHeuresFonctionnement = selected.nombre_heures_fonctionnement != null ? String(selected.nombre_heures_fonctionnement) : '';
      this.nombreLitresAspires = String(selected.nombre_litres_aspires || '');
      this.presenceCartouche = selected.presence_cartouche;
      this.testMoteur = !!selected.test_moteur;
      this.commentaire = selected.commentaire;
      this.macCarteElectronique = selected.code_mac_carte_electronique;
      this.statutCapteurId = selected.statut_capteur_id ?? null;
    }
  }

  

    onCapteurFabriqueInputChange(value: string): void {
      if (value && value.length > 1) {
        this.filteredCapteursFabriques = this.capteurs.filter(c =>
          c.numero_serie?.toLowerCase().includes(value.toLowerCase())
        );
      } else {
        this.filteredCapteursFabriques = [];
      }
      this.selectedCapteurId = '';
    }

    onCapteurFabriqueSelected(event: any): void {
      const capteur = event.option.value;
      this.capteurFabriqueInput = `${capteur.numero_serie}`;
      this.selectedCapteurId = capteur.id;
      this.onCapteurSelect();
    }

  protected submit(): void {
    this.error = '';
    this.success = '';

    if (!this.selectedCapteurId) {
      this.error = 'Veuillez sélectionner un capteur.';
      return;
    }

    if (!this.numeroSerie.trim()) {
      this.error = 'Le numéro de série est requis.';
      return;
    }

    const nombreHeuresFonctionnement = this.normalizeNombreHeuresFonctionnement(this.nombreHeuresFonctionnement);
    if (nombreHeuresFonctionnement === null) {
      return;
    }

    const payload: CapteurPayload = {
      type_capteur: this.typeCapteur || undefined,
      ligne_commande_id: this.selectedLigneCommandeId ?? undefined,
      numero_serie: this.numeroSerie.trim(),
      numero_nomenclature: Number(this.numeroNomenclature),
      date_assemblage: this.dateAssemblage || undefined,
      cartouche_a: this.cartoucheAId,
      cartouche_b: this.isSingleCartoucheType() ? null : this.cartoucheBId,
      date_emballage: this.dateEmballage || undefined,
      code_bon_retour: this.codeBonRetour || undefined,
      code_bon_retour_cartouches: this.codeBonRetourCartouches || undefined,
      date_envoi: this.dateEnvoi || undefined,
      date_expedition: this.dateExpeditionCapteur || undefined,
      reference_envoi: this.referenceEnvoi || undefined,
      date_retour: this.dateRetour || undefined,
      nombre_heures_fonctionnement: nombreHeuresFonctionnement,
      nombre_litres_aspires: this.nombreLitresAspires ? Number(this.nombreLitresAspires) : undefined,
      presence_cartouche: this.presenceCartouche,
      test_moteur: this.testMoteur,
      commentaire: this.commentaire || undefined,
      code_mac_carte_electronique: this.macCarteElectronique || undefined,
      statut_capteur_id: this.statutCapteurId ?? undefined,
    };

    this.loading = true;
    this.zone.run(() => {
      this.capteurService.update(Number(this.selectedCapteurId), payload).subscribe({
        next: () => {
          this.success = 'Capteur modifié avec succès.';
          this.loadCapteurs();
          this.loading = false;
          this.cdr.markForCheck();
        },
        error: (err: HttpErrorResponse) => {
          this.error = `Erreur lors de la modification: ${this.getErrorMessage(err)}`;
          this.loading = false;
          this.cdr.markForCheck();
        }
      });
    });
  }

  private loadCapteurs(): void {
    this.loadingCapteurs = true;
    this.zone.run(() => {
      this.capteurService.list().subscribe({
        next: (capteurs) => {
          this.capteurs = capteurs;
          if (this.pendingCapteurId) {
            this.selectedCapteurId = String(this.pendingCapteurId);
            this.onCapteurSelect();
            this.pendingCapteurId = null;
          }
          this.loadingCapteurs = false;
          this.filteredCapteursFabriques = [];
          this.cdr.markForCheck();
        },
        error: (err: HttpErrorResponse) => {
          this.error = `Erreur lors du chargement: ${this.getErrorMessage(err)}`;
          this.loadingCapteurs = false;
          this.cdr.markForCheck();
        }
      });
    });
  }

  private loadLots(): void {
    this.zone.run(() => {
      this.lotsService.list().subscribe({
        next: (lots) => {
          this.lotsCartouches = lots;
          this.cdr.markForCheck();
        },
        error: (err: HttpErrorResponse) => {
          console.error('Erreur chargement lots:', err);
        }
      });
    });
  }

  private loadNomenclatures(): void {
    this.loadingNomenclatures = true;
    this.zone.run(() => {
      this.nomenclaturesService.list().subscribe({
        next: (nomenclatures) => {
          this.nomenclatures = nomenclatures;
          this.loadingNomenclatures = false;
          this.cdr.markForCheck();
        },
        error: (err: HttpErrorResponse) => {
          this.error = `Erreur lors du chargement des nomenclatures: ${this.getErrorMessage(err)}`;
          this.loadingNomenclatures = false;
          this.cdr.markForCheck();
        }
      });
    });
  }

  private getErrorMessage(err: HttpErrorResponse): string {
    if (typeof err.error === 'string' && err.error.trim()) {
      return err.error;
    }

    if (err.error?.detail) {
      return err.error.detail;
    }

    if (err.error?.message) {
      return err.error.message;
    }

    if (err.error && typeof err.error === 'object') {
      return JSON.stringify(err.error);
    }

    if (err.status === 0) {
      return 'Impossible de contacter le serveur';
    }

    if (err.statusText) {
      return `${err.status} - ${err.statusText}`;
    }

    return 'Erreur inconnue';
  }
}
